import "firebase/auth";
import firebase from "firebase";
import authServices from "./authServices";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const firebaseConfig = {
    apiKey: "AIzaSyD6axLMmzljiR8ED4LfIKMWy04bYgo5M2c",
    authDomain: "icomply-dev.firebaseapp.com",
    databaseURL: "https://icomply-dev-default-rtdb.firebaseio.com",
    projectId: "icomply-dev",
    storageBucket: "icomply-dev.appspot.com",
    messagingSenderId: "595017364361",
    appId: "1:595017364361:web:0afa06e5047dbb004de758",
    measurementId: "G-83JVXSC0PZ",
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

export const auth = firebase.auth();

export var emailSignUpHandler = (e, email, password) => {
    e.preventDefault();

    return auth
        .createUserWithEmailAndPassword(email, password)
        .then(async (result) => {
            //console.log(result);
            const token = await result.user.getIdToken();
            authServices.setAuthInfo(token);
            authServices.setUID(result.user.uid);
            //console.log(token);

            result.user.sendEmailVerification();

            //console.log(result.user.getIdToken())

            // firebase
            //   .database()
            //   .ref("users/" + result.user.uid)
            //   .set({
            //     email: result.user.email,
            //   }).then(()=>{
            //     authServices.setAuthInfo(result.user.uid);
            //   })
            //   .catch((err) => {
            //     //console.log(err)
            //   });

            return true ;
        })
        .catch((err) => {
            return err ;
        });

    
};

export var emailLoginHandler = (e, email, password) => {
    e.preventDefault();
    return auth
        .signInWithEmailAndPassword(email, password)
        .then(async (result) => {
            //console.log(result);
            // authServices.setAuthInfo(result.user.uid);
            // authServices.setEmailInfo(email);

            const token = await result.user.getIdToken();
            authServices.setAuthInfo(token);
            authServices.setUID(result.user.uid);
            //console.log(token);
            return true ;
        })
        .catch((err) => {
            return err ;
        });
};

export const logout = () => {
    auth.signOut().then(()=>{
        cookies.remove("authenticated",{ path: '/' });
        cookies.remove("token",{ path: '/' });
        cookies.remove("email",{ path: '/' });
        cookies.remove("uid",{ path: '/' });
        cookies.remove("di_o",{ path: '/' });
        cookies.remove("subscriptionData",{ path: '/' });
        cookies.remove("nsw_access_token",{ path: '/' });
        cookies.remove("aXNzdXBlcmFkbWlu",{ path: '/' });
        //console.log("User Signed Out");
    }).catch(()=>{
        console.error("Unable to Signout");
    });
};



export const isAuthenticated = () => {
    // if (auth.currentUser === null) return false;
    if (cookies.get("authenticated") === "true") {
        return true;
    } else {
        return false;
    }
};

export default firebase;
